import { constants } from '@/config';

const AddProduct = () => import('@/app/library/pages/AddProduct.vue');
const App = () => import('@/app/library/App.vue');
const MediaLibrary = () => import('@/app/library/pages/MediaLibrary.vue');
const MetaAdCampaigns = () => import('@/app/library/pages/MetaAdCampaigns.vue');
const BoardsIndex = () => import('@/app/boards/pages/BoardsIndex.vue');
const Products = () => import('@/app/ecommerce/pages/Products.vue');

const PAGE_LEVEL_TOP = `Library`;

export default {
  path: 'library',
  component: App,
  meta: {
    requiresAuth: true,
    allowsAds: true,
  },
  children: [
    {
      name: 'library',
      path: '',
      redirect: { name: 'library.index' },
    },
    {
      // route for open media popup externally
      name: 'library.media',
      path: 'media/:id',
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - View Media`,
        modal: {
          component: 'MediaPopup',
        },
      },
    },
    {
      // route for media upload popup
      name: 'library.media.upload',
      path: 'media/upload',
      meta: {
        modal: {
          component: 'UploadPopup',
        },
        analytics: `${PAGE_LEVEL_TOP} - Upload Media`,
      },
    },
    {
      name: 'library.index',
      // have to give it a unique path,
      // otherwise 'Find Media' item in the side menu will always be highlighted
      // because we are not using 'exact match' mode (shows highlight if there is a route/child route match)
      path: 'discover',
      component: MediaLibrary,
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Find Media`,
      },
    },
    {
      path: 'galleries',
      children: [
        {
          name: 'library.galleries',
          path: '',
          component: BoardsIndex,
          props: {
            galleryType: constants.LIBRARY,
          },
          meta: {
            analytics: `${PAGE_LEVEL_TOP} - Galleries`,
          },
        },
      ],
    },
    {
      path: 'products',
      children: [
        {
          name: 'library.products',
          path: '',
          component: Products,
          meta: {
            analytics: `${PAGE_LEVEL_TOP} - Products`,
          },
          children: [
            {
              name: 'library.products.new',
              path: 'new',
              component: AddProduct,
              meta: {
                analytics: `${PAGE_LEVEL_TOP} - New Product`,
              },
            },
          ],
        },
      ],
    },
    {
      name: 'library.metaAdCampaigns',
      path: 'meta-ad-campaigns',
      component: MetaAdCampaigns,
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Meta Ad Campaigns`,
      },
    },
  ],
};
